export class GenericModel {
  static factory(model = {}) {
    return model;
  }
}
